import DiagnosisButton from './components/DiagnosisButton/DiagnosisButton';
import OrganReviewButton from './components/OrganReviewButton';

/**
 * getToolbarModule does NOT register buttons. It registers `evaluate` functions
 * (ExtensionManager.ts:501-510) and supplies the uiType -> defaultComponent registry read
 * by ToolbarService._getButtonUITypes:471-485.
 *
 * It is not optional either: _mapButtonToDisplay:583 dereferences buttonType.defaultComponent
 * BEFORE its own null-guard at :586, so a button whose uiType has no entry throws a
 * TypeError rather than warning. Every new uiType needs an entry here.
 */
export default function getToolbarModule() {
  return [
    // Mandatory, not conventional. _mapButtonToDisplay:583 assigns
    // btn.component = buttonType.defaultComponent BEFORE its own !buttonType guard at
    // :586 — and that guard's console.warn at :587 is unreachable on every path, since
    // arriving there requires having passed :582-584 with btn.component truthy, which
    // makes the guard's condition false. So an unregistered uiType either throws a
    // TypeError or is accepted in silence; it never warns.
    {
      name: 'sycai.diagnosisButton',
      defaultComponent: DiagnosisButton,
    },
    {
      name: 'sycai.organReviewButton',
      defaultComponent: OrganReviewButton,
    },
  ];
}
